var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBtnWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67158 5.20733C8.28106 4.81681 8.28106 4.18364 8.67158 3.79312L10.7929 1.6718C11.1834 1.28128 11.8166 1.28128 12.2071 1.6718L14.3284 3.79312C14.719 4.18364 14.719 4.81681 14.3284 5.20733L12.2071 7.32865C11.8166 7.71918 11.1834 7.71918 10.7929 7.32865L8.67158 5.20733ZM3 2.00023C2.44772 2.00023 2 2.44794 2 3.00023V6.00023C2 6.55251 2.44772 7.00023 3 7.00023H6C6.55228 7.00023 7 6.55251 7 6.00023V3.00023C7 2.44794 6.55228 2.00023 6 2.00023H3ZM3 9.00023C2.44772 9.00023 2 9.44794 2 10.0002V13.0002C2 13.5525 2.44772 14.0002 3 14.0002H6C6.55228 14.0002 7 13.5525 7 13.0002V10.0002C7 9.44794 6.55228 9.00023 6 9.00023H3ZM10 9.00023C9.44772 9.00023 9 9.44794 9 10.0002V13.0002C9 13.5525 9.44772 14.0002 10 14.0002H13C13.5523 14.0002 14 13.5525 14 13.0002V10.0002C14 9.44794 13.5523 9.00023 13 9.00023H10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnWidget);
export default __webpack_public_path__ + "static/media/icn_btn_widget.3ff4af646e25c9565ab67e59dd699c85.svg";
export { ForwardRef as ReactComponent };